<template>
  <v-card>
    <v-toolbar color="indigo" dense fixed>
      <v-toolbar-title class="white--text">Modifica Zona</v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- Salva e Invia Ordine -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="salvaModifica" small v-bind="attrs" v-on="on">
            <v-icon color="success"> mdi-floppy </v-icon>
          </v-btn>
        </template>
        <span>Salva Zona</span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <!-- Chiudi Diario -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="chiudiDialogZona" small v-bind="attrs" v-on="on"
            ><v-icon color="error">mdi-close</v-icon></v-btn
          >
        </template>
        <span>Chiudi</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text class="mt-2 pa-0">
      <v-container>
        <v-row justify="center" align="center">
          <v-col cols="4">
            <v-text-field
              label="Codice"
              v-model="zona_sel_tmp.cod_quesito"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              label="Descrizione"
              v-model="zona_sel_tmp.des_quesito"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
import Zona from "@/classes/EMZona.js";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "ModificaZona",
  components: { SnackbarQV },
  props: {
    visible: { type: Boolean, default: true },
    zona_sel: { type: Object, default: () => new Zona() },
  },
  data() {
    return {
      // Variabili d'appoggio
      zona_sel_tmp: new Zona(),

      // Modal bool
      // Array
    };
  },
  computed: {},
  watch: {
    visible: {
      immediate: true,
      handler() {
        if (this.visible === true) {
          this.zona_sel_tmp = new Zona(this.zona_sel);
        }
      },
    },
  },
  methods: {
    chiudiDialogZona() {
      this.$emit("click_chiudi");
    },
    salvaModifica() {
      const zona_save = Object.assign({}, this.zona_sel_tmp);
      this.$emit("salva_zona", zona_save);
    },
  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style> 
